<template>
	<v-col class="input-ro">
		<ModalConfirm ref="modalConfirm" :msg="msgConfirm" @action="processRO"></ModalConfirm>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Tambah RO</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-credit-card-sync</v-icon>
			<div class="pl-2">Repeat Order</div>
			<div class="px-2">/</div>
			<div>Tambah RO</div>
		</div>
		<div class="mt-5">
			<div v-if="!suksesRO">
				<div v-if="!loading">
					<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
						<div v-if="listAllAvaSerial.length > 0">
							<v-radio-group v-model="checkedSerial">
								<v-row class="ml-0">
									<v-col cols="12" sm="6" md="3" xl="3" class="pl-0 pb-0" v-for="(serial, i) in listAllAvaSerial" :key="i">
										<v-card class="pa-3 elevation-0 rounded-lg hover-shadow" @click="checkSerial(serial.serial_member_stock_serial_id)">
											<v-row>
												<v-col cols="2" sm="2" md="2" class="my-auto">
													<v-radio on-icon="mdi-circle-slice-8" off-icon="mdi-checkbox-blank-circle-outline" class="mt-0" :value="serial.serial_member_stock_serial_id" @click="checkSerial(serial.serial_member_stock_serial_id)"></v-radio>
												</v-col>
												<v-col cols="10" sm="10" md="10">
													<v-row>
														<v-col cols="12" md="12" class="pl-0 pb-0 d-flex flex-row align-center justify-space-between">
															<div class="font-size-10 cl-grey">Serial</div>
															<div class="font-size-11 font-size-xs-11 cl-primary font-weight-600">{{ serial.serial_member_stock_serial_id }}</div>
														</v-col>
														<v-col cols="12" md="12" class="pl-0 pb-2 pt-1 d-flex flex-row align-center justify-space-between">
															<div class="font-size-10 cl-grey">Serial PV</div>
															<div class="font-size-11 cl-grey font-weight-600">{{ serial.serial_member_stock_serial_pv | toNumber }}</div>
														</v-col>
														<v-col md="12" class="pl-0 pt-1 d-flex flex-row align-center justify-space-between">
															<div class="font-size-10 cl-grey">Pembelian</div>
															<div class="font-size-10 cl-grey font-weight-500">{{ serial.serial_member_stock_datetime | tanggal }}</div>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
								</v-row>
							</v-radio-group>
							<div class="my-3">
								<v-row justify="center">
									<v-col cols="9" sm="4" md="3" xl="2" v-if="allAvaSerialPagination.total_page > 1 && allAvaSerialPagination.next > 0">
										<v-btn block large outlined class="bg-white rounded-lg" color="primary" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="loadMore">
											<v-icon>mdi-sync-circle</v-icon>
											<span class="pl-2">Muat Lebih Banyak</span>
										</v-btn>
									</v-col>
									<v-col cols="9" sm="3" md="2" xl="1" class="pt-0 pt-sm-3 pl-sm-0">
										<v-btn block large depressed class="bg-primary white--text rounded-lg" :loading="btnLoadingProses" :disabled="btnProses" @click="showConfirm">
											<v-icon>mdi-arrow-right-bold-circle</v-icon>
											<span class="pl-2">Proses</span>
										</v-btn>
									</v-col>
								</v-row>
							</div>
						</div>
					</v-scroll-x-reverse-transition>
					<div v-if="listAllAvaSerial.length == 0">
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
									<NoData></NoData>
									<div class="pt-3 text-center cl-secondary">Tidak ada data serial yang dapat ditampilkan</div>
								</v-card>
							</v-col>
						</v-row>
					</div>
				</div>
				<div class="mt-3" v-if="loading">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<LoadData :loading="loading"></LoadData>
						</v-col>
					</v-row>
				</div>
			</div>
			<div v-if="suksesRO">
				<v-row>
					<v-col cols="12">
						<v-alert border="right" colored-border color="primary" class="mb-0 rounded-lg hover-shadow">
							<div class="d-flex">
								<v-icon color="primary">mdi-information</v-icon>
								<div class="pl-3 cl-primary font-weight-500">Selamat Anda Berhasil Melakukan Repeat Order Dengan Serial {{ responSuksesRO.serial_id }}</div>
							</div>
						</v-alert>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" class="mt-3 mt-sm-0">
						<div class="text-center">
							<v-btn large depressed class="bg-primary white--text rounded-lg" :loading="btnLoadingBack" :disabled="btnLoadingBack" @click="backInput">
								<span class="pl-2">Tambah RO Kembali</span>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalConfirm from '@/components/modals/vo/ModalConfirm';

export default {
	components: {
		ModalConfirm
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '12',
			serial: [],
			checkedSerial: '',
			btnLoadingProses: false,
			btnProses: true,
			btnLoadingBack: false,
			suksesRO: false,
			msgConfirm: 'Yakin ingin melakukan Repeat Order?',
		}
	},
	computed: {
		...mapState('serial', ['listAllAvaSerial', 'allAvaSerialPagination']),
		...mapState('repeatOrder', ['responSuksesRO']),
	},
	methods: {
		...mapActions('serial', ['getAllAvaSerial', 'getLoadAllAvaSerial']),
		...mapActions('repeatOrder', ['inputRO']),

		getData() {
			this.loading = true
			this.getAllAvaSerial({ limit:this.limit, page: this.page, sort: 'serial_member_serial_is_used', dir: 'asc', serial_type: 'bin', start_type_id: 7, end_type_id: 7 }).then(() => {
				this.loading = false
			})
		},
		checkSerial(serial) {
			if (this.checkedSerial == serial)
				this.checkedSerial = ''
			else
				this.checkedSerial = serial
			this.enableProses()
		},
		loadMore() {
			this.btnLoadingProses = true
			this.page += 1
			this.getLoadAllAvaSerial({ limit:this.limit, page: this.page, sort: 'serial_member_serial_is_used', dir: 'asc', serial_type: 'bin', start_type_id: 7, end_type_id: 7 }).then(() => {
				this.btnLoadingProses = false
			})
		},
		enableProses() {
			if (this.checkedSerial)
				this.btnProses = false
			else
				this.btnProses = true
		},
		showConfirm() {
			this.$refs.modalConfirm.modalShow()
		},
		processRO() {
			this.$refs.modalConfirm.loadingButton()
			let params = {
				serial_id: this.checkedSerial,
				network_type: 'bin'
			}
			this.inputRO(params).then(() => {
				this.checkedSerial = ''
				this.$refs.modalConfirm.normalButton()
				this.$refs.modalConfirm.modalHide()
				this.suksesRO = true
			}).catch(() => {
				this.$refs.modalConfirm.normalButton()
			})
		},
		backInput() {
			this.limit = '12'
			this.page = 1
			this.btnLoadingBack = true
			this.btnProses = true
			this.getAllAvaSerial({ limit:this.limit, page: this.page, sort: 'serial_member_serial_is_used', dir: 'asc', serial_type: 'bin', start_type_id: 7, end_type_id: 7 }).then(() => {
				this.btnLoadingBack = false
				this.suksesRO = false
			})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Tambah RO`)
		this.getData()
	}
};
</script>